// state is not the application state, only the state this
// reducer is responsible for.
import {FETCH_STATS_FOR_GAME, GAME_SELECTED, UPDATE_STAT} from "../constants/ActionTypes";

// Returns a single game object
export default function (state = null, action) {

   switch (action.type) {
      case GAME_SELECTED:
         const newGameId = action.payload;
         if (!state) return null;

         // wipe out if gameId's don't match
         if (state.gameId !== newGameId) return null;

         return state;

      case FETCH_STATS_FOR_GAME:
         const payload = action.payload;

         if (payload) {
            return payload;         // payload is of the form: { stats: stats, gameId: game.id }
         } else {
            return state;
         }
      case UPDATE_STAT:
         // if game is null, create it.
         if (!action.payload) {
            return state;
         }
         const { userId, gameId, username } = action.payload;

         // if no state, nothing to do
         if (!state) return null;

         // ensure gameIds match
         if ( gameId !== state.gameId ) return state;

         const newStats = [];
         let foundIt = false;
         // find userId and insert username
         for (var i=0; i < state.stats.length; i++ ) {
            if (userId === state.stats[i].userId) {
               state.stats[i].username = username;
               foundIt = true;
            }
            newStats.push(state.stats[i]);
         }
         if (foundIt) {
            return { ...state, stats: newStats };
         } else {
            return state;
         }
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_game_stats.js